import React, { useState } from "react";
import { deleteComment } from "../../../api/commentAPI";
import AdminFormModal from "../_shared/AdminFormModal";

const CommentModal = ({ comments, onClose }) => {
  const [commentList, setCommentList] = useState(comments || []);

  const handleDeleteComment = async (id) => {
    try {
      await deleteComment(id);
      setCommentList(commentList.filter((c) => c.id !== id));
    } catch (error) {
      console.error("Failed to delete comment:", error);
    }
  };

  return (
    <AdminFormModal
      title="Komentar Pembaca"
      subtitle={`Total: ${commentList.length} komentar`}
      onClose={onClose}
      size="md"
    >
      {commentList.length === 0 ? (
        <div className="text-center py-12 rounded-2xl bg-slate-50 border border-dashed border-slate-200">
          <div className="text-4xl mb-2">💬</div>
          <p className="text-sm text-slate-500 font-overpass">
            Belum ada komentar pada artikel ini.
          </p>
        </div>
      ) : (
        <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-1">
          {commentList.map((comment) => (
            <div
              key={comment.id}
              className="group flex items-start gap-3 p-4 rounded-2xl bg-slate-50 hover:bg-white border border-slate-100 hover:border-brand-200 transition-all"
            >
              <div className="w-10 h-10 flex-shrink-0 rounded-full bg-gradient-to-br from-brand-500 to-eco-500 flex items-center justify-center text-white text-sm font-bold shadow-md">
                {comment.name?.charAt(0).toUpperCase() || "?"}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 mb-1">
                  <h5 className="font-oswald font-semibold text-slate-900 text-sm truncate">
                    {comment.name}
                  </h5>
                  <button
                    onClick={() => handleDeleteComment(comment.id)}
                    className="opacity-0 group-hover:opacity-100 flex-shrink-0 w-8 h-8 rounded-lg bg-red-50 hover:bg-red-100 text-red-600 flex items-center justify-center transition-all"
                    title="Hapus komentar"
                  >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
                <p className="text-sm text-slate-700 font-overpass leading-relaxed break-words">
                  {comment.comment}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </AdminFormModal>
  );
};

export default CommentModal;
